import React from 'react';
import {
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  InputAdornment,
  Switch
} from "material-ui";
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import Typography from "material-ui/Typography/Typography";
import tsl from "app/tsl";
import ExpansionPanel from "material-ui/ExpansionPanel/ExpansionPanel";
import EditationFlightRoute from "app/used/offers/routes/EditationFlightRoute";
import axios from 'axios';
import { Select, TextField, withValidatedInputs, Validations, DateTimePicker } from '../../../../components/forms';
import Grid from 'material-ui/Grid';
import {Close, Done, Delete, Restore } from "material-ui-icons";
import moment from 'moment-timezone';
import RouteEdit from '../RouteEdit';
import { getSettings } from 'utils/client';

class EditRequest extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      requestId: props.match.params.id,
      data: null,
      aircrafts: null,
      statuses: null,
      locations: null,
      panelStatus: {
        0: true,
        1: true,
        2: true,
        3: true,
        4: true
      },
      postsToDelete: {},
      settings: null
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id !== this.state.requestId) {
      this.setState({
        requestId: nextProps.match.params.id,
        data: null
      }, this.loadData);
    }
  }

  componentDidMount() {
    axios.get('/api/operator/aircraft/models').then((res) => {
        this.setState({
            aircrafts: res.data.data
        });
    });

    axios.get('/api/operator/requests/statuses').then((res) => {
        this.setState({
            statuses: res.data
        });
    });

    axios.get('/api/operator/flight/locations', {
      params: {
        perPage: 1000
      }
    }).then((res) => {
        this.setState({
            locations: res.data.data
        });
    });

    axios.get('/api/operator/settings').then((res) => {
        this.setState({
            settings: res.data
        });
    });

    this.loadData();
  }

  loadData = () => {
    const { match } = this.props;

    axios.get(`/api/operator/requests/${match.params.id}`).then(
      (res) => {
        this.setState({
          data: res.data,
          postsToDelete: {}
        });
      }
    )
  };

  handleRouteChange = (route) => {
    this.setState(state => ({
      data: {
        ...state.data,
        route,
      }
    }));
  };

  handleInputChange = (e) => {
    // save the target because it will be nullified when the setState callback happens
    const target = e.target;

    this.setState(state => ({
      data: {
        ...state.data,
        [target.name]: target.value
      }
    }));
  };

  handleSwitchChange = (e, checked) => {
    const target = e.target;

    this.setState(state => ({
      data: {
        ...state.data,
        [target.name]: checked
      }
    }));
  };

  createToggleDeletePost = (post) => () => {
    this.setState(state => ({
      postsToDelete: {
        ...state.postsToDelete,
        [post.id]: !state.postsToDelete[post.id]
      }
    }));
  };

  togglePanel = (panelIndex) => () => {
    this.setState({
      panelStatus: {
        ...this.state.panelStatus,
        [panelIndex]: !this.state.panelStatus[panelIndex]
      }
    });
  };

  handleSave = () => {
    if (this.props.trySubmit()) {
      axios.post(`/api/operator/requests/${this.state.requestId}`, {
        ...this.state.data,
        deleted_posts: Object.keys(this.state.postsToDelete).filter(id => !!this.state.postsToDelete[id])
      }).then(res => {
        // this.loadData();
        this.props.history.goBack();
      });
    }
  };

  handleCancel = () => {
    this.props.history.goBack();
  };

  handleTimeChange = (name) => (value) => {
    this.setState(state => ({
      data: {
        ...state.data,
        [name]: value.format('YYYY-MM-DD HH:mm:ss')
      }
    }));
  };

  getPickupPointName = () => {
    const { route } = this.state.data;

    if (route.points.length > 0) {
      const pointName = route.points[0].name || route.points[0].gps_lat + ', ' + route.points[0].gps_long;

      return route.points[0].location ? route.points[0].location.name : pointName;
    }

    return null;
  };

  getDropOffPointName = () => {
    const { route } = this.state.data;

    if (route.points.length <= 1) {
      return this.getPickupPointName();
    }

    const lastItem = route.points.length - 1;
    const pointName = route.points[lastItem].name || route.points[lastItem].gps_lat + ', ' + route.points[lastItem].gps_long;

    return route.points[lastItem].location ? route.points[lastItem].location.name : pointName;
  };

  render() {

    const { formActions } = this.props;
    const { data, aircrafts, statuses, locations } = this.state;

    // don't render anything until we have all data
    if (data === null || aircrafts === null || statuses === null || locations === null) {
      return null;
    }

    const selectedAircraft = data.aircraft_model_id ? aircrafts.find(a => a.id === data.aircraft_model_id) : null;

    return (
      <div>
        <ExpansionPanel expanded={this.state.panelStatus[0]} onChange={this.togglePanel(0)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>{tsl('requests.edit.details')}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container>
                <Grid item xs={12}>
                  <h2>{tsl('requests.edit.title', data)}</h2>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                      <InputLabel>{tsl('requests.edit.status')}</InputLabel>
                      <Select
                          name="status_id"
                          value={data.status_id || 0}
                          onChange={this.handleInputChange}
                      >
                        {statuses.map(s => (
                          <MenuItem key={s.id} value={s.id}>{s.title}</MenuItem>
                        ))}
                      </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    value={this.getPickupPointName() || tsl('requests.edit.not_specified')}
                    disabled
                    label={tsl('requests.edit.pickup_location')}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    value={this.getDropOffPointName() || tsl('requests.edit.not_specified')}
                    disabled
                    label={tsl('requests.edit.drop_off_location')}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                      <InputLabel>{tsl('requests.edit.time.time_range_type')}</InputLabel>
                      <Select
                          name="is_time_range"
                          value={data.is_time_range ? 1 : 0}
                          onChange={this.handleInputChange}
                      >
                          <MenuItem value={0}>{tsl('requests.edit.time.exact')}</MenuItem>
                          <MenuItem value={1}>{tsl('requests.edit.time.range')}</MenuItem>
                      </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={data.is_time_range ? 4 : 8}>
                  <DateTimePicker
                    formActions={formActions}
                    required
                    fullWidth
                    label={tsl('requests.edit.time.from')}
                    name="time_from"
                    value={data.time_from || ''}
                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                    ampm={getSettings('ampm', false)}
                    format="LLL"
                    showTabs={false}
                    onChange={this.handleTimeChange('time_from')}
                    validations={
                        [
                          data.is_time_range ? Validations.createIsNotLaterThan({
                            label: tsl('requests.edit.time.to'),
                            value: data.time_to
                          }) : () => true
                        ]
                      }
                  />
                </Grid>

                {
                  data.is_time_range > 0 &&
                  <Grid item xs={12} sm={4}>
                    <DateTimePicker
                      formActions={formActions}
                      required
                      fullWidth
                      label={tsl('requests.edit.time.to')}
                      name="time_to"
                      value={data.time_to || ''}
                      leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                      rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                      ampm={getSettings('ampm', false)}
                      format="LLL"
                      showTabs={false}
                      onChange={this.handleTimeChange('time_to')}
                      validations={
                        [
                          Validations.createIsNotSoonerThan({
                            label: tsl('requests.edit.time.from'),
                            value: data.time_from
                          })
                        ]
                      }
                    />
                  </Grid>
                }

                <Grid item xs={12}>
                  <FormControl fullWidth>
                        <InputLabel htmlFor="language">{tsl('requests.edit.aircraft.model')}</InputLabel>
                        <Select
                            name="aircraft_model_id"
                            value={data.aircraft_model_id || ''}
                            onChange={this.handleInputChange}
                        >
                            <MenuItem value="">{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                            {aircrafts.map((aircraft) => {
                                return (<MenuItem key={aircraft.id} value={aircraft.id}>{aircraft.name}</MenuItem>);
                            })}
                        </Select>
                        <FormHelperText id="aircraft-model-text">{selectedAircraft ? tsl('requests.edit.aircraft.passengers', selectedAircraft) : ''}</FormHelperText>
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    name="note"
                    value={data.note || ''}
                    disabled
                    multiline
                    rows={3}
                    label={tsl('requests.edit.note')}
                  />
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={this.state.panelStatus[1]} onChange={this.togglePanel(1)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>{tsl('requests.edit.contact')}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <TextField
                    formActions={formActions}
                    required
                    fullWidth
                    name="first_name"
                    value={data.first_name || ''}
                    label={tsl('requests.edit.contact.first_name')}
                    onChange={this.handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    formActions={formActions}
                    required
                    fullWidth
                    name="last_name"
                    value={data.last_name || ''}
                    label={tsl('requests.edit.contact.last_name')}
                    onChange={this.handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    formActions={formActions}
                    required
                    fullWidth
                    name="email"
                    value={data.email || ''}
                    label={tsl('requests.edit.contact.email')}
                    onChange={this.handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    formActions={formActions}
                    fullWidth
                    name="phone"
                    value={data.phone || ''}
                    label={tsl('requests.edit.contact.phone')}
                    onChange={this.handleInputChange}
                  />
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={this.state.panelStatus[2]} onChange={this.togglePanel(2)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>{tsl('requests.edit.operator_remarks')}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <TextField
                    formActions={formActions}
                    fullWidth
                    name="flight_time"
                    value={data.flight_time || ''}
                    label={tsl('requests.edit.flight_time')}
                    onChange={this.handleInputChange}
                    validations={
                      [Validations.isInteger]
                    }
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{tsl('requests.edit.minutes')}</InputAdornment>
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    formActions={formActions}
                    fullWidth
                    name="flight_cost"
                    value={data.flight_cost || ''}
                    label={tsl('requests.edit.flight_cost')}
                    onChange={this.handleInputChange}
                    validations={
                      [Validations.isNumeric]
                    }
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{this.state.settings && this.state.settings.currency_code}</InputAdornment>
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    formActions={formActions}
                    fullWidth
                    name="aircraft_blocking_time"
                    value={data.aircraft_blocking_time || ''}
                    label={tsl('requests.edit.aircraft_blocking_time')}
                    onChange={this.handleInputChange}
                    validations={
                      [Validations.isInteger]
                    }
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{tsl('requests.edit.minutes')}</InputAdornment>
                    }}
                  />
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={this.state.panelStatus[3]} onChange={this.togglePanel(3)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>{tsl('requests.edit.operator_note.list')}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    multiline
                    rows={3}
                    fullWidth
                    name="operator_note"
                    value={data.operator_note || ''}
                    label={tsl('requests.edit.operator_note.new')}
                    onChange={this.handleInputChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  {data.thread && data.thread.posts.length > 0 ?
                    <List>
                    {
                    data.thread.posts.sort((a, b) => -(a.id - b.id)).map(post => (
                      <ListItem button key={post.id}>
                        <ListItemText
                          primary={<span>{moment(post.created_at).format('LLL')}{' | '}{post.user.name}</span>}
                          secondary={post.text}
                        />
                        <ListItemSecondaryAction>
                          <IconButton
                            onClick={this.createToggleDeletePost(post)}
                            color={this.state.postsToDelete[post.id] ? 'primary' : 'default'}
                          >
                            {this.state.postsToDelete[post.id] ? <Restore /> : <Delete />}
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))
                    }
                    </List>
                    : null
                  }
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={this.state.panelStatus[4]} onChange={this.togglePanel(4)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>{tsl('requests.edit.route')}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container>
                <Grid item xs={12}>
                  <Switch
                    checked={data.roundtrip}
                    name="roundtrip"
                    onChange={this.handleSwitchChange}
                  />
                  <InputLabel>{tsl('requests.edit.roundtrip')}</InputLabel>
                </Grid>

                <Grid item xs={12}>
                  <RouteEdit
                    onChange={this.handleRouteChange}
                    locations={locations}
                    route={data.route}
                    roundtrip={data.roundtrip}
                  />
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>

        <Button fab raised
            className="jr-fab-btn jr-btn-fab-sm text-white"
            style={{position: "fixed", bottom: 5, right: 70, zIndex: 9999}}
            onClick={this.handleCancel}
        >
            <Close />
        </Button>

        <Button fab raised color="accent"
            className="jr-fab-btn text-white"
            style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
            onClick={this.handleSave}
            disabled={!this.props.isFormValid}
        >
            <Done />
        </Button>
      </div>
    );
  }
}

export default withValidatedInputs(
  EditRequest
);


// WEBPACK FOOTER //
// ./app/used/requests/routes/Edit.js